import type { SvgIconProps } from '../../types/props.ts'

export const TikTokIconDark = (props: SvgIconProps) => {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden={true}
      role="img"
      {...props}
    >
      <path
        d="M0 5.99252C0 2.68294 2.9305 0 6.54546 0H41.4545C45.0695 0 48 2.68294 48 5.99252V42.0075C48 45.3171 45.0695 48 41.4545 48H6.54545C2.9305 48 0 45.3171 0 42.0075V5.99252Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M6.5459 0.5H41.4541C44.8352 0.5 47.4998 2.99952 47.5 5.99219V42.0078C47.4998 45.0005 44.8352 47.5 41.4541 47.5H6.5459C3.16476 47.5 0.500199 45.0005 0.5 42.0078V5.99219C0.500198 2.99952 3.16476 0.5 6.5459 0.5Z"
        stroke="white"
        strokeOpacity="0.1"
      />
      <g clipPath="url(#clip0_12079_15664)">
        <path
          d="M31.2494 19.478C33.3736 20.9786 35.9762 21.8616 38.787 21.8616V16.517C38.2549 16.517 37.7244 16.4621 37.2041 16.3534V20.5603C34.5012 20.5642 31.8651 19.7306 29.6662 18.1767V29.0834C29.6662 34.5395 25.1897 38.9624 19.6683 38.9624C17.6861 38.9657 15.748 38.3839 14.1025 37.2913C15.918 39.1256 18.4499 40.2635 21.251 40.2635C26.7729 40.2635 31.2494 35.8408 31.2494 30.3844V19.478ZM33.2019 14.0861C32.085 12.8834 31.3989 11.351 31.2494 9.72498V9.0376H29.7492C30.1271 11.1658 31.4149 12.984 33.2021 14.0861M17.595 33.1045C16.9883 32.3188 16.6604 31.3574 16.6619 30.3689C16.6619 27.8735 18.7095 25.8502 21.2355 25.8502C21.7059 25.8502 22.174 25.9214 22.6228 26.0619V20.5979C22.0986 20.5267 21.5695 20.4966 21.0404 20.5079V24.7608C20.5915 24.6201 20.1233 24.5487 19.6524 24.5492C17.1264 24.5492 15.079 26.5722 15.079 29.0679C15.079 30.8327 16.1025 32.3605 17.595 33.1045Z"
          fill="#FF004F"
        />
        <path
          d="M29.6659 18.1767C31.8649 19.7306 34.5011 20.5642 37.2041 20.5603V16.3529C35.6639 16.0274 34.2648 15.2349 33.2019 14.0859C31.4144 12.984 30.1266 11.1658 29.749 9.0376H25.8084V30.3842C25.7997 32.8728 23.7556 34.8879 21.2353 34.8879C19.7498 34.8879 18.4304 34.1883 17.5944 33.1045C16.1023 32.3605 15.079 30.8327 15.079 29.0681C15.079 26.5727 17.1261 24.5492 19.6521 24.5492C20.1361 24.5492 20.6027 24.6236 21.0402 24.7608V20.5079C15.6157 20.6187 11.2531 24.9982 11.2531 30.3844C11.2531 33.073 12.3394 35.5105 14.1027 37.2913C15.7483 38.3837 17.6862 38.9655 19.6683 38.9624C25.19 38.9624 29.6662 34.5395 29.6662 29.0836V18.1769L29.6659 18.1767Z"
          fill="white"
        />
        <path
          d="M37.2041 16.3531V15.2157C35.7892 15.2178 34.4023 14.8263 33.2019 14.0859C34.2644 15.2355 35.6636 16.0282 37.2041 16.3531ZM29.749 9.03759C29.713 8.8343 29.6854 8.62973 29.6662 8.4239V7.73651H24.2255V29.0834C24.2168 31.5717 22.173 33.5868 19.6521 33.5868C18.9121 33.5868 18.2134 33.4133 17.5944 33.1048C18.4304 34.1883 19.7498 34.8879 21.2353 34.8879C23.7556 34.8879 25.7997 32.8727 25.8087 30.3844V9.03759H29.749ZM21.0402 20.5079V19.2971C20.5856 19.2354 20.1274 19.2047 19.6686 19.2051C14.1464 19.2048 9.67018 23.6277 9.67018 29.0834C9.67018 32.5038 11.4294 35.5181 14.1027 37.2913C12.3394 35.5105 11.2531 33.073 11.2531 30.3844C11.2531 24.9982 15.6154 20.6187 21.0402 20.5079Z"
          fill="#00F2EA"
        />
      </g>
      <defs>
        <clipPath id="clip0_12079_15664">
          <rect
            width="32.9021"
            height="32.527"
            fill="white"
            transform="translate(7.61379 7.73651)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
